import { ComponentPropsWithoutRef } from 'react'

export const EvaluationMenuIcon = ({
  variant = 'horizontal',
  ...props
}: ComponentPropsWithoutRef<'svg'> & {
  variant?: 'horizontal' | 'vertical'
}) => {
  return variant === 'horizontal' ? (
    <svg
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12851_2870)">
        <path
          d="M10 15C10 13.625 8.875 12.5 7.5 12.5C6.125 12.5 5 13.625 5 15C5 16.375 6.125 17.5 7.5 17.5C8.875 17.5 10 16.375 10 15ZM12.5 15C12.5 16.375 13.625 17.5 15 17.5C16.375 17.5 17.5 16.375 17.5 15C17.5 13.625 16.375 12.5 15 12.5C13.625 12.5 12.5 13.625 12.5 15ZM20 15C20 16.375 21.125 17.5 22.5 17.5C23.875 17.5 25 16.375 25 15C25 13.625 23.875 12.5 22.5 12.5C21.125 12.5 20 13.625 20 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ) : (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 10.5C11.1562 10.5 10.5 11.1875 10.5 12C10.5 12.8438 11.1562 13.5 12 13.5C12.8125 13.5 13.5 12.8438 13.5 12C13.5 11.1875 12.8125 10.5 12 10.5ZM10.5 7.25C10.5 8.09375 11.1562 8.75 12 8.75C12.8125 8.75 13.5 8.09375 13.5 7.25C13.5 6.4375 12.8125 5.75 12 5.75C11.1562 5.75 10.5 6.4375 10.5 7.25ZM10.5 16.75C10.5 17.5938 11.1562 18.25 12 18.25C12.8125 18.25 13.5 17.5938 13.5 16.75C13.5 15.9375 12.8125 15.25 12 15.25C11.1562 15.25 10.5 15.9375 10.5 16.75Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const CopyLinkIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5716 4.4287C10.6444 3.50149 9.0896 3.50149 8.16241 4.4287L7.31078 5.28031C7.10251 5.48859 6.76482 5.48859 6.55653 5.28031C6.34826 5.07203 6.34826 4.73434 6.55653 4.52606L7.40816 3.67445C8.7519 2.33068 10.9821 2.33068 12.3258 3.67445C13.6696 5.01821 13.6696 7.24839 12.3258 8.59212L11.4742 9.44375C11.2659 9.65201 10.9283 9.65201 10.72 9.44375C10.5117 9.23548 10.5117 8.89777 10.72 8.68951L11.5716 7.83788C12.4988 6.91068 12.4988 5.3559 11.5716 4.4287ZM9.97745 6.02283C10.1857 6.23112 10.1857 6.5688 9.97745 6.77708L6.77745 9.97708C6.56917 10.1853 6.23148 10.1853 6.0232 9.97708C5.81492 9.76881 5.81492 9.43111 6.0232 9.22284L9.22321 6.02283C9.43147 5.81456 9.76918 5.81456 9.97745 6.02283ZM5.28068 6.55617C5.48895 6.76445 5.48895 7.10215 5.28068 7.31041L4.42906 8.16204C3.50186 9.08924 3.50186 10.644 4.42906 11.5712C5.35627 12.4984 6.91105 12.4984 7.83825 11.5712L8.68987 10.7196C8.89814 10.5113 9.23585 10.5113 9.44411 10.7196C9.65238 10.9279 9.65238 11.2656 9.44411 11.4739L8.59249 12.3255C7.24875 13.6692 5.01858 13.6692 3.67482 12.3255C2.33105 10.9817 2.33105 8.75153 3.67482 7.4078L4.52643 6.55617C4.73471 6.34789 5.07239 6.34789 5.28068 6.55617Z"
      fill="currentColor"
    />
  </svg>
)

export const DuplicateIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6179)">
      <path
        d="M13.333 2.66671V10.6667H5.33301V2.66671H13.333ZM13.333 1.33337H5.33301C4.59967 1.33337 3.99967 1.93337 3.99967 2.66671V10.6667C3.99967 11.4 4.59967 12 5.33301 12H13.333C14.0663 12 14.6663 11.4 14.6663 10.6667V2.66671C14.6663 1.93337 14.0663 1.33337 13.333 1.33337ZM2.66634 4.00004H1.33301V13.3334C1.33301 14.0667 1.93301 14.6667 2.66634 14.6667H11.9997V13.3334H2.66634V4.00004Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const DownloadIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6185)">
      <path
        d="M13.3337 7.99996L12.3937 7.05996L8.66699 10.78V2.66663H7.33366V10.78L3.61366 7.05329L2.66699 7.99996L8.00033 13.3333L13.3337 7.99996Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const ArchiveIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4.77869C2 3.61787 2.89646 2.66663 4.06589 2.66663H6.1285C6.79698 2.66663 7.4368 2.90008 7.91698 3.46134L8.60676 4.12532H11.786C12.9554 4.12532 13.8519 5.07656 13.8519 6.23738V11.2212C13.8519 12.3821 12.9554 13.3333 11.786 13.3333H4.06589C2.89646 13.3333 2 12.3821 2 11.2212V4.77869ZM4.06589 3.85181C3.58523 3.85181 3.18519 4.2377 3.18519 4.77869V11.2212C3.18519 11.7622 3.58523 12.1481 4.06589 12.1481H11.786C12.2666 12.1481 12.6667 11.7622 12.6667 11.2212V6.23738C12.6667 5.69639 12.2666 5.3105 11.786 5.3105H8.36794C8.21464 5.3105 8.06738 5.25113 7.95698 5.14485L7.07295 4.29394C7.05719 4.27873 7.04219 4.26264 7.02821 4.24577C6.80361 3.97558 6.51022 3.85181 6.1285 3.85181H4.06589Z"
      fill="currentColor"
    />
  </svg>
)

export const DeleteIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6198)">
      <path
        d="M10.6663 6V12.6667H5.33301V6H10.6663ZM9.66634 2H6.33301L5.66634 2.66667H3.33301V4H12.6663V2.66667H10.333L9.66634 2ZM11.9997 4.66667H3.99967V12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V4.66667Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const VersionsIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6203)">
      <path
        d="M5.33366 10.6667H10.667V12H5.33366V10.6667ZM5.33366 8.00004H10.667V9.33337H5.33366V8.00004ZM9.33366 1.33337H4.00033C3.26699 1.33337 2.66699 1.93337 2.66699 2.66671V13.3334C2.66699 14.0667 3.26033 14.6667 3.99366 14.6667H12.0003C12.7337 14.6667 13.3337 14.0667 13.3337 13.3334V5.33337L9.33366 1.33337ZM12.0003 13.3334H4.00033V2.66671H8.66699V6.00004H12.0003V13.3334Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const SelectedIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6211)">
      <path
        d="M5.99993 10.7999L3.19993 7.99994L2.2666 8.93328L5.99993 12.6666L13.9999 4.66661L13.0666 3.73328L5.99993 10.7999Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const RecoverIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00033 2.66671C5.05366 2.66671 2.66699 5.05337 2.66699 8.00004H1.33366L3.15366 9.82004L3.18699 9.88671L5.06699 8.00004H3.66699C3.66699 5.60671 5.60699 3.66671 8.00033 3.66671C10.3937 3.66671 12.3337 5.60671 12.3337 8.00004C12.3337 10.3934 10.3937 12.3334 8.00033 12.3334C6.80699 12.3334 5.72699 11.84 4.94699 11.0534L4.24033 11.76C5.20033 12.7267 6.52699 13.3334 8.00033 13.3334C10.947 13.3334 13.3337 10.9467 13.3337 8.00004C13.3337 5.05337 10.947 2.66671 8.00033 2.66671ZM7.33366 5.33337V8.66671L10.167 10.3467L10.667 9.50671L8.33366 8.12004V5.33337H7.33366Z"
      fill="currentColor"
    />
  </svg>
)

export const NewVersionIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12853_6230)">
      <path
        d="M7.99967 4.66671C7.63301 4.66671 7.33301 4.96671 7.33301 5.33337V7.33337H5.33301C4.96634 7.33337 4.66634 7.63337 4.66634 8.00004C4.66634 8.36671 4.96634 8.66671 5.33301 8.66671H7.33301V10.6667C7.33301 11.0334 7.63301 11.3334 7.99967 11.3334C8.36634 11.3334 8.66634 11.0334 8.66634 10.6667V8.66671H10.6663C11.033 8.66671 11.333 8.36671 11.333 8.00004C11.333 7.63337 11.033 7.33337 10.6663 7.33337H8.66634V5.33337C8.66634 4.96671 8.36634 4.66671 7.99967 4.66671ZM7.99967 1.33337C4.31967 1.33337 1.33301 4.32004 1.33301 8.00004C1.33301 11.68 4.31967 14.6667 7.99967 14.6667C11.6797 14.6667 14.6663 11.68 14.6663 8.00004C14.6663 4.32004 11.6797 1.33337 7.99967 1.33337ZM7.99967 13.3334C5.05967 13.3334 2.66634 10.94 2.66634 8.00004C2.66634 5.06004 5.05967 2.66671 7.99967 2.66671C10.9397 2.66671 13.333 5.06004 13.333 8.00004C13.333 10.94 10.9397 13.3334 7.99967 13.3334Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
